import React from "react"
import {Col, Drawer, Form, Radio, Row, Select} from "antd"
import { Button } from "src/components/actions/button"
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg"
import { useAppData } from "src/store/app-data"
import { getFormattedLangData, getInitialValues } from "src/utils/helpers"
import styled from "styled-components"
import {TranslatableInput, TranslatableTextarea} from "../../components/Translatable";
import {DebounceSelect} from "../../components/debounce-select";
import {getProductHints} from "../../utils/getProductHints";

export function EditDrawer({ title, initialValues, onClose, onSave,categoryOptions, duplicateCategoryInit = null }) {
  const layoutConfig = useAppData((state) => state.layoutConfig)

  const [form] = Form.useForm()

  React.useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(getInitialValues(initialValues))
    }
    if (duplicateCategoryInit) {
      form.setFieldValue('duplicateProductCategoryId', duplicateCategoryInit)
    }
  }, [initialValues, duplicateCategoryInit])

  async function onSubmit(values) {
    const formatted = {
      ...(initialValues.id && { id:initialValues.id, _method: "PUT"}),
      ...values,
      isActive: values.isActive ? 1 : 0,
      productIds: values.productIds.map((product) => product.value),
    }
    const data = getFormattedLangData(formatted)

    try {
      await onSave(data, initialValues.id ? initialValues.id : undefined)

      onClose()
      form.resetFields()
    } catch (e) {
      console.log(e)
    }
  }

  function handleClose() {
    onClose()
    form.resetFields()
  }

  const id = initialValues?.id ?? "new"

  return (
    <DrawerEdit
      width={layoutConfig.isMobile ? "90%" : "80%"}
      title={title}
      onClose={handleClose}
      open
    >
      <FormEdit
        form={form}
        layout={"vertical"}
        onFinish={(values) => onSubmit(values)}
      >
        <StyledFormItem label={"Название"}>
          <TranslatableInput name={"name"} id={id}></TranslatableInput>
        </StyledFormItem>

        <StyledFormItem label={"Название для пользователя"}>
          <TranslatableInput name={"nameForUsers"} id={id}></TranslatableInput>
        </StyledFormItem>

        <StyledFormItem label={"Описание"}>
          <TranslatableTextarea name={"description"} id={id}></TranslatableTextarea>
        </StyledFormItem>

        <StyledFormItem
          key={id + "_isActive"}
          label={"Включен"}
          name={"isActive"}
          initialValue={form.isActive ? form.isActive : true}
          rules={[
            {
              required: true,
              message: "Выберите вариант!",
            },
          ]}
        >
          <Radio.Group
            buttonStyle="solid"
            value={form.isActive ? form.isActive : true}
          >
            <Radio.Button value={true}>Да</Radio.Button>
            <Radio.Button value={false}>Нет</Radio.Button>
          </Radio.Group>
        </StyledFormItem>

        <StyledFormItem
            key={id + "_productIds"}
            label={"Товары в категории"}
            name={"productIds"}
        >
          <DebounceSelect
              mode="multiple"
              value={""}
              placeholder="Выберите продукт"
              fetchOptions={getProductHints}
              style={{
                width: "100%",
              }}
          />
        </StyledFormItem>


        <StyledFormItem
            key={id + "_duplicateProductCategoryId"}
            label={"Дубликат категории (можно оставить пустым)"}
            name={"duplicateProductCategoryId"}
        >
          <Select
              options={categoryOptions}
              showSearch
              optionFilterProp="label"
              allowClear
              placeholder="Выбрать категорию"
          />
        </StyledFormItem>

        <ButtonRow>
          <ButtonCol>
            <Button
              danger
              onClick={() => {
                if (initialValues) {
                  form.setFieldsValue(getInitialValues(initialValues))
                  return
                }
                form.resetFields()
              }}
              icon={<RotateClockwiseSvg />}
            >
              Вернуть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button onClick={handleClose} icon={<CloseSvg />}>
              Закрыть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button icon={<SaveSvg />} type="primary" htmlType="submit">
              Сохранить
            </Button>
          </ButtonCol>
        </ButtonRow>
      </FormEdit>
    </DrawerEdit>
  )
}

const DrawerEdit = styled(Drawer)``

const FormEdit = styled(Form)``

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`